import { useEffect, useRef, useState } from 'react';

export default function EditorialReviews() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const reviews = [
    {
      text: 'Each poem in this collection feels like a soft whisper in a noisy world — honest, unfiltered, and emotionally resonant.',
      author: 'Ayu Ve',
      role: 'Content Creator',
      rating: 5
    },
    {
      text: 'Vibrant and encouraging enthusiasm.',
      author: 'Anonymous',
      role: 'Blog Reader',
      rating: 5
    },
    {
      text: 'Truly reflects today\'s reality. Brilliant!',
      author: 'Anonymous',
      role: 'Blog Reader',
      rating: 5
    },
    {
      text: 'Powerful and deeply relevant — it captures the present moment perfectly.',
      author: 'Anonymous',
      role: 'Blog Reader',
      rating: 5
    }
  ];

  return (
    <section ref={sectionRef} className="py-24 px-6 bg-gradient-to-br from-rose-50/50 via-purple-50/30 to-white">
      <div className="container mx-auto max-w-7xl">
        <div className={`transition-all duration-1000 transform ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <div className="text-center mb-16">
            <h2 className="text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-purple-600 to-rose-500 bg-clip-text text-transparent" style={{ fontFamily: '"Playfair Display", serif' }}>
              Editorial Reviews
            </h2>
            <p className="text-xl text-gray-600" style={{ fontFamily: '"Lora", serif' }}>
              What readers and creators say about my work
            </p>
            <div className="w-24 h-1 bg-gradient-to-r from-purple-500 to-rose-500 mx-auto rounded-full mt-6"></div>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            {reviews.map((review, index) => (
              <div
                key={index}
                className={`group bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 border border-gray-100 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
                style={{ transitionDelay: `${200 + index * 100}ms` }}
              >
                <div className="flex items-center mb-4">
                  {[...Array(review.rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-2xl text-yellow-400"></i>
                  ))}
                </div>
                <p className="text-lg text-gray-700 leading-relaxed mb-6 italic" style={{ fontFamily: '"Lora", serif' }}>
                  "{review.text}"
                </p>
                <div className="flex items-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-gradient-to-br from-purple-500 to-rose-500 text-white font-bold text-lg">
                    {review.author.charAt(0)}
                  </div>
                  <div className="ml-4">
                    <p className="font-bold text-gray-800">{review.author}</p>
                    <p className="text-sm text-gray-500">{review.role}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
